import { BulkCreateTransferOrderFeature } from "./BulkCreateTransferOrderFeature";

export default BulkCreateTransferOrderFeature;
